// Story 11.1 — tipos compartidos del editor. Espejo de
// `apps/api/src/routes/bots/files-helpers.ts` para no acoplar el frontend
// al package del backend.

export type FileKind = 'bot-config' | 'flow' | 'voice' | 'hours' | 'test' | 'ext-ts' | 'unknown';

export interface FileTreeFile {
  path: string;
  name: string;
  type: 'file';
  extension: string;
  kind: FileKind;
  readOnly: boolean;
}

export interface FileTreeDir {
  path: string;
  name: string;
  type: 'dir';
  children: FileTreeNode[];
}

export type FileTreeNode = FileTreeFile | FileTreeDir;

export interface FileContent {
  path: string;
  content: string;
  mimeType: string;
  readOnly: boolean;
}

export interface ValidationProblem {
  code: string;
  message: string;
  location?: { line?: number; column?: number; filePath?: string };
  suggestion?: string;
}

export interface ValidationReport {
  ok: boolean;
  errors: ValidationProblem[];
  warnings: ValidationProblem[];
}

export interface SaveFileResult {
  saved: boolean;
  validation: ValidationReport;
}

/** Inferir el lenguaje Monaco a partir del path. */
export function languageForPath(path: string): 'yaml' | 'typescript' | 'plaintext' {
  if (path.endsWith('.yaml') || path.endsWith('.yml')) return 'yaml';
  if (path.endsWith('.ts') || path.endsWith('.tsx')) return 'typescript';
  return 'plaintext';
}

export function fileKindFromPath(path: string): FileKind {
  if (path === 'bot.yaml') return 'bot-config';
  if (path === 'voice.yaml') return 'voice';
  if (path === 'hours.yaml') return 'hours';
  if (/^flows\//.test(path)) return 'flow';
  if (/^tests\//.test(path)) return 'test';
  if (/^ext\//.test(path)) return 'ext-ts';
  return 'unknown';
}

/**
 * Aplana un FileTree a una lista de archivos (omite directorios). Útil para
 * keyboard navigation y listas planas.
 */
export function flattenFiles(tree: FileTreeNode[]): FileTreeFile[] {
  const out: FileTreeFile[] = [];
  function walk(nodes: FileTreeNode[]): void {
    for (const n of nodes) {
      if (n.type === 'file') out.push(n);
      else walk(n.children);
    }
  }
  walk(tree);
  return out;
}
